
import 'grapesjs/dist/css/grapes.min.css';
import 'grapesjs-preset-newsletter/dist/grapesjs-preset-newsletter.css';

import grapesjs from 'grapesjs';
import 'grapesjs-preset-newsletter';

export default function link(scope, element, attrs) {

    let editor;

    function render () {
		if (editor) {
			editor.destroy();
			editor = null;
		}
        const components = scope && scope.html || '';
        editor = grapesjs.init({
            container : element[0],
            components,
			storageManager: false,
			plugins: ['gjs-preset-newsletter'],
			pluginsOpts: {
				'gjs-preset-newsletter': {
					modalTitleImport: 'Import template',
					// ... other options
				},
            },
        });
        editor.on('update', () => {
            scope.$apply(function () {
                const html = `<style>${editor.getCss()}</style>${editor.getHtml()}`;
                scope.html = html;
            });
        });
    }

    scope.$watch('config', function() {
        render();
    });

};



// WEBPACK FOOTER //
// ./src/directive/email-editor/email-editor.link.js